<script setup lang="ts">
  import {Model} from "@/app/Model";
  import {FiltriFamiglia, FamigliaAdmin} from "@/app/data/FamigliaAdmin";

  let model: Model = Model.getReactiveInstance();
  const emit = defineEmits(["recalc"]);

  function handleSubmit(): void {
    //resetto per evitare di portarmi dietro l'offset se sono andato avanti con la paginazione
    model.fam_admin.paginazioneFamiglia_start = 0;

    emit("recalc");
  }
  function resetFiltri(): void {
    model.fam_admin.filtriFamiglia = new FiltriFamiglia();
    handleSubmit();
  }
</script>

<template>
<div class="admin-filtri mb-2 row">
  <div class="col-4 mb-2">
    <label for="filtri_idDocMaster">ID Doc Master</label>
    <input type="number" class="form-control" id="filtri_idDocMaster" v-model.number="model.fam_admin.filtriFamiglia.id_doc_master">
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_oggettoDiGiudizio">Oggetto del giudizio</label>
    <select class="form-select" id="filtri_oggettoDiGiudizio" v-model="model.fam_admin.filtriFamiglia.oggetto_di_giudizio">
      <option value="">Tutti</option>
      <option v-for="item in Model.lista_oggetto_di_giudizio" :value="item">{{ item }}</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_modificaManuale">Modifica Manuale</label>
    <select class="form-select" id="filtri_modificaManuale" v-model="model.fam_admin.filtriFamiglia.modifica_manuale">
      <option value="">Tutti</option>
      <option value="true">Modificati</option>
      <option value="false">Non modificati</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortField">Ordinamento: Campo</label>
    <select class="form-select" id="filtri_sortField" v-model="model.fam_admin.filtriFamiglia.sort_field">
      <option v-for="(item) in FamigliaAdmin.sort_fields" :value="item" :key="'field_'+item">{{ item }}</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortOrder">Ordinamento: Direzione</label>
    <select class="form-select" id="filtri_sortOrder" v-model="model.fam_admin.filtriFamiglia.sort_order">
      <option value="DESC">DESC</option>
      <option value="ASC">ASC</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <div>&nbsp;</div>
    <button type="button" class="btn btn-primary me-1" @click="handleSubmit()">Filtra</button>
    <button type="button" class="btn btn-sm btn-secondary" @click="resetFiltri()">Reset</button>
  </div>
</div>
</template>